import {Trans} from '../../i18n/trans';
import {Product} from '../product';
import {CheckIcon} from '@common/icons/material/Check';

interface FeatureListProps {
  product: Product;
}

export function ProductFeatureList({product}: FeatureListProps) {
  if (!product.feature_list.length) return null;

  return (
    <div className="mt-28 border-t pt-24">
      <p className="mb-14 text-xs font-bold uppercase tracking-wider text-muted">
        <Trans message="What's included" />
      </p>
      <ul className="space-y-10">
        {product.feature_list.map(feature => (
          <li key={feature} className="flex items-start gap-10 text-sm">
            <span className="mt-1 flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-primary/10">
              <CheckIcon className="text-primary" size="xs" />
            </span>
            <span className="leading-snug text-main">
              <Trans message={feature} />
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
